import SidePanel from "PFComponents/side_panel/side_panel";
import React from "react";
import { useTranslation } from "react-i18next";

import { useActivityPageContext } from "../activity_page_context";
import { ActivityHistoryProvider } from "./activity_history_context";
import { HistoryEntriesList, HistorySort } from "./parts";

export const ActivityHistorySidePanel = () => {
  const { t } = useTranslation("activities", { keyPrefix: "show.history" });
  const { showHistorySidePanel, toggleHistorySidePanel } = useActivityPageContext();

  return (
    <ActivityHistoryProvider>
      <SidePanel
        show={showHistorySidePanel}
        onClose={toggleHistorySidePanel}
        title={t("modal.title")}
        actions={<HistorySort />}
        fullHeight
      >
        <HistoryEntriesList />
      </SidePanel>
    </ActivityHistoryProvider>
  );
};
